import React, { useEffect, useState } from 'react';
import styles from "./Potable.module.css";
import styless from '../allEnquiresTab/specificationsTab.module.css';
import { Refresh } from '../../../../Svg';
import Calendar from 'react-calendar/dist/cjs/Calendar.js';
import 'react-calendar/dist/Calendar.css';
import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { formateDate } from '../../../../Website/utils/utils';
import api from '../../../../Website/utils/api';
import { setScheduleOrderRefresh } from '../../../../Website/redux/scheduleOrderSlice';
import { useDispatch } from 'react-redux';

const ActionButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    marginRight: theme.spacing(1),
    fontSize: '14px',
    '&:hover': {
        backgroundColor: theme.palette.grey[200],
    },
}));

const Reschedulecomp = ({ data }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [showCalendar, setShowCalendar] = useState("");
    const [rescheduleData, setRescheduleData] = useState({});
    const { id } = useParams()
    const [loading, setLoading] = useState(false)
    const [quantityErrors, setQuantityErrors] = useState({});

    const handleCalClick = (id) => {
        setShowCalendar(prevState => (prevState === id ? "" : id));
    };

    const validateQuantity = (productNumber, value) => {
        const product = data?.find(p => p._id === productNumber);
        if (!product?.productId) return false;

        const minMultiplier = product?.productId?.inventory?.minimumMultiplier || 1;
        const numValue = Number(value);

        if (value === '' || isNaN(numValue)) {
            setQuantityErrors(prev => ({ ...prev, [productNumber]: 'Please enter a valid number' }));
            return false;
        }

        if (numValue <= 0) {
            setQuantityErrors(prev => ({ ...prev, [productNumber]: 'Quantity must be greater than 0' }));
            return false;
        }

        if (numValue % minMultiplier !== 0) {
            setQuantityErrors(prev => ({
                ...prev,
                [productNumber]: `Quantity must be in multiples of ${minMultiplier}`
            }));
            return false;
        }

        setQuantityErrors(prev => ({ ...prev, [productNumber]: '' }));
        return true;
    };

    const handleQuantityChange = (e, productId) => {
        const value = e.target.value;
        setRescheduleData(prev => ({
            ...prev,
            [productId]: {
                ...prev[productId],
                rescheduledQuantity: Number(value),
            },
        }));

        validateQuantity(productId, value)
    };


    useEffect(() => {
        const initialErrors = {};

        // rescheduleData[item._id]?.rescheduledQuantity !== undefined
        data?.forEach(product => {
            if (product?.productId && product?.productId?.inventory) {
                const minMultiplier = product?.productId?.inventory?.minimumMultiplier || 1;
                const numValue = Number(rescheduleData[product?._id]?.rescheduledQuantity || 0);

                if (numValue % minMultiplier !== 0) {
                    initialErrors[product._id] =
                        `Quantity must be in multiples of ${minMultiplier}`;
                }
            }
        });
        setQuantityErrors(initialErrors);
    }, [data.length]);

    const handleDateChange = (date, productId) => {
        setRescheduleData(prev => ({
            ...prev,
            [productId]: {
                ...prev[productId],
                rescheduleDate: date,
            },
        }));
        setShowCalendar("");
    };


    const handleDispatch = async () => {
        const missingEntries = [];

        data.forEach(item => {
            const entry = rescheduleData[item._id];
            if (!entry || !entry.rescheduledQuantity || !entry.rescheduleDate) {
                missingEntries.push(item?.productId?.productOverview?.productNumber?.[0] || "Unknown Product");
            }
        });

        if (missingEntries.length > 0) {
            toast.error(`Please provide required quantity and reschedule date for:\n\n${missingEntries.join('\n')}`);
            return;
        }

        const finalPayload = data.map(item => ({
            productId: item.productId ? (item.productId._id || item.productId) : "",
            productNumber: item?.productId?.productOverview?.productNumber?.[0] || "",
            rescheduleDate: rescheduleData[item._id]?.rescheduleDate,
            rescheduledQuantity: rescheduleData[item._id]?.rescheduledQuantity,
        }));

        console.log("Final Payload:", finalPayload);
        const finaldata = {
            id,
            products: finalPayload
        }
        setLoading(true)
        try {
            const response = await api.rescheduleOrder(finaldata)
            if (response.data) {
                toast.success("Order rescheduled successfully")
                dispatch(setScheduleOrderRefresh())
                navigate(-1)
            }
        } catch (err) {
            console.log(err);
            toast.error(err?.response?.data?.message || "something went wrong")

        } finally {
            setLoading(false)
        }

    };


    // Reset/clear the reschedule data state when "Cancel" is clicked.
    const handleCancel = () => {
        setRescheduleData({});
        setShowCalendar("");
    };

    const handleRefresh = (id) => {
        setRescheduleData(prev => {
            const updated = { ...prev };
            delete updated[id]; // Or reset it with empty values: updated[id] = { rescheduledQuantity: "", rescheduleDate: "" }
            return updated;
        });
    };


    return (
        <div className={styless.profilebodyContainer}>
            <div className={styless.profileheader}>
                <h2>Reschedule Order</h2>
                <button className={styless.editbtn} onClick={() => navigate(-1)}>
                    Back to details
                </button>
            </div>
            <table className={styles.previewtable}>
                <thead>
                    <tr>
                        <th className={styles.previewth}>Part #</th>
                        <th className={styles.previewth}>Manufacture</th>
                        <th className={styles.previewth}>Pending QTY</th>
                        <th className={styles.previewth}>Required QTY</th>
                        <th className={styles.previewth}>Reschedule</th>
                    </tr>
                </thead>
                <tbody>
                    {data?.map((item) => (
                        <tr key={item.id} className={styles.previewstripedRow}>
                            <td className={styles.previewtd}>
                                <div style={{ display: 'flex', alignItems: "center", gap: "6px" }}>
                                    <img src='/assets/Comparator.png' alt="product" />
                                    <div>
                                        {item?.productId?.productOverview?.productNumber?.[0] || "-"}
                                    </div>
                                </div>
                            </td>
                            <td className={styles.previewtd}>
                                {item?.productId?.productOverview?.manufacturer?.[0]?.name || "-"}
                            </td>
                            <td className={styles.previewtd}>
                                {item.quantity}
                            </td>
                            <td className={styles.previewtd}>
                                <input
                                    type="text"
                                    placeholder="Enter qty"
                                    className={styles.dataInput}
                                    value={
                                        rescheduleData[item._id]?.rescheduledQuantity !== undefined
                                            ? rescheduleData[item._id].rescheduledQuantity
                                            : ""
                                    }
                                    onChange={(e) => handleQuantityChange(e, item._id)}
                                />
                                {quantityErrors[item?._id] && (
                                    <div className={styles.errorText}>
                                        {quantityErrors[item?._id]}
                                    </div>
                                )}
                            </td>
                            <td className={styles.previewtd} style={{ display: 'flex', alignItems: 'center', gap: "10px" }}>
                                <div style={{ position: 'relative' }}>
                                    <ActionButton
                                        onClick={() => handleCalClick(item._id)}
                                        sx={{
                                            color: '#979797',
                                            border: '0.5px solid #9F9F9F',
                                            background: 'transparent',
                                            borderRadius: '6px',
                                            width: "190px",
                                            justifyContent: "flex-start",
                                            marginBottom: "9px"
                                        }}
                                    >
                                        {rescheduleData[item._id]?.rescheduleDate
                                            ? new Date(rescheduleData[item._id].rescheduleDate).toLocaleDateString()
                                            : "Select date"}
                                    </ActionButton>
                                    {showCalendar === item._id && (
                                        <div className="calendar" style={{ position: 'absolute', zIndex: 10 }}>
                                            <Calendar
                                                onChange={(date) => handleDateChange(date.toISOString(), item._id)}
                                                value={rescheduleData[item._id]?.rescheduleDate || new Date()}
                                            />
                                        </div>
                                    )}
                                </div>
                                <div onClick={() => handleRefresh(item._id)} style={{ cursor: 'pointer' }}>

                                    <Refresh />
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className={styles.mainBtns}>
                <button className={styles.quoteBtn} onClick={handleCancel}>Cancel</button>
                <button className={styles.addBtn} onClick={handleDispatch} disabled={loading}>{loading ? "please wait.." : "Dispatch"}</button>
            </div>
        </div>
    );
};

export default Reschedulecomp;
